
export const financeiro = [
  {
    text: 'Análise',
    value: 'descricao_analise',
    css_header: 'pl-2'
  },
  {
    text: "Total de sku's",
    value: 'qtde_produtos',
  },
  {
    text: 'Proj. de venda (R$ venda)',
    value: 'cmm_em_preco_venda',
  },
  {
    text: '%Projeção',
    value: 'porcentual_projecao',
  },
  {
    text: 'Estoque (R$ custo)',
    value: 'estoque_em_preco_custo',
  },
  {
    text: 'Cobertura estoque',
    value: 'cobertura_estoque',
  },
  {
    text: 'Estoque parametrizado (R$ custo)',
    value: 'estoque_parametrizavel_preco_custo',
  },
  {
    text: 'Cobertura parametrizada',
    value: 'cobertura_estoque_parametrizavel',
  },
  {
    text: 'Total a Comprar Atual',
    value: 'sugestao_compra_preco_custo',
  },
  {
    text: 'Total a aumentar',
    value: 'total_estoque_para_aumentar_preco_custo',
    css_header: 'pl-1',
    style: {
      background: '#e6ffe5 !important',
      borderLeft: '1px solid #e8e8e8'
    }
  },
  {
    text: 'Total a reduzir',
    value: 'total_estoque_para_reduzir_preco_custo',
    css_header: 'pl-1',
    style: {
      background: '#fdebeb !important',
      borderLeft: '1px solid #d9d8d8'
    }
  }
];

export const quantitativo = [
  {
    text: 'Análise',
    value: 'descricao_analise',
    css_header: 'pl-2'
  },
  {
    text: "Total de sku's",
    value: 'qtde_produtos',
  },
  {
    text: 'Proj. de venda',
    value: 'cmm_quantidade',
  },
  {
    text: '%Projeção',
    value: 'porcentual_projecao',
  },
  {
    text: 'Estoque',
    value: 'estoque_quantidade',
  },
  {
    text: 'Cobertura estoque',
    value: 'cobertura_estoque',
  },
  {
    text: 'Estoque parametrizado',
    value: 'estoque_parametrizavel_quantidade',
  },
  {
    text: 'Cobertura parametrizada',
    value: 'cobertura_estoque_parametrizavel',
  },
  {
    text: 'Total a Comprar Atual',
    value: 'sugestao_compra_quantidade',
  },
  {
    text: 'Total a aumentar',
    value: 'total_estoque_para_aumentar_quantidade',
    css_header: 'pl-1',
    style: {
      background: '#e6ffe5 !important',
      borderLeft: '1px solid #e8e8e8'
    }
  },
  {
    text: 'Total a reduzir',
    value: 'total_estoque_para_reduzir_quantidade',
    css_header: 'pl-1',
    style: {
      background: '#fdebeb !important',
      borderLeft: '1px solid #e8e8e8'
    }
  }
];
